// リクエスト中断（ユーザーによるページ離脱・遷移や AbortController によるキャンセル）だけを判定する。
// ユーザー操作起因のノイズであり不具合ではないため、Sentry へは送らない判定に使う。
//
// MEMO:
// axios はリクエストのタイムアウトにも `code: "ECONNABORTED"` を使い回しており、
// このアプリの axios インスタンス（CustomApiFactory.tsx）は
// `transitional.clarifyTimeoutError: false`（既定値）のままなので、
// タイムアウト時の message は "timeout of Xms exceeded" 等になる。
// タイムアウトは本物の不具合（サーバ遅延・無限待ち等）の可能性があり握り潰してはいけないため、
// `ECONNABORTED` は XHR の onabort（ユーザー離脱）でのみ付与される
// message === "Request aborted" のときだけ true にする。
export const isRequestAbortedError = (error: unknown): boolean => {
  if (!error || typeof error !== "object") return false;

  const code = (error as { code?: string }).code;
  const name = (error as { name?: string }).name;
  const message = (error as { message?: string }).message;

  if (code === "ERR_CANCELED") return true;
  if (name === "CanceledError") return true;
  if (code === "ECONNABORTED" && message === "Request aborted") return true;

  return false;
};
